export default __webpack_public_path__ + "b034735c7c658b8a4587108919611917.gif";